import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';
import { getCentralSystem } from '@infuse/api/e-connector/central-system';
import { CentralSystem, mapToDomain } from '@infuse/e-connector/central-system/domain';

export const useCentralSystem = () => {
  const fetchCentralSystemId = ref<string | undefined>(undefined);

  const query = useQuery<CentralSystem>({
    queryKey: ['central-systems', 'detail', fetchCentralSystemId],
    enabled: () => !!fetchCentralSystemId.value,
    queryFn: async () => {
      const response = await getCentralSystem({ id: fetchCentralSystemId.value });
      return mapToDomain(response);
    }
  });

  return {
    ...query,
    fetchCentralSystemId,
    centralSystem: query.data
  };
};
